export interface ReportParams {
    dateFrom?: string
    dateTo?: string
    view?: string
    consultationType?: string
}

export enum MedicalAreaReports {
    MEDICAL_PAYMENTS = 'MEDICAL_PAYMENTS'
}